import React, { useState, useEffect } from "react";
import { MapInteractionCSS } from "react-map-interaction";
import { Grid, Icon, Label, Segment, Header, Card, Button, Image } from "semantic-ui-react";
import moment from "moment";

const ScansCenter = ({
	center,
	scans,
	removeScanOrdo,
	getScansForTVsecretariat,
	refreshCenterScans,
	addScanOrdoToPrescription,
	prescriptions,
	getAllScansOrdo,
}) => {
	const [selectedScan, setSelectedScan] = useState(scans.length === 1 ? scans[0] : null);

	const refresh = (clean = false) => {
		if (addScanOrdoToPrescription && getScansForTVsecretariat) getScansForTVsecretariat(false, null, clean, center?.id);
		else if (center && refreshCenterScans) refreshCenterScans(center?.id, null);
		else if (getAllScansOrdo) getAllScansOrdo();
	};
	useEffect(() => {
		return () => setSelectedScan(null);
	}, []);

	return (
		<Segment placeholder>
			<Grid>
				<Grid.Row columns={selectedScan ? 2 : 1}>
					<Header style={{ marginLeft: "10px", width: "100%" }}>
						<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
							<div>
								<Icon name="file pdf outline" />
								{scans.length === 0 ? "Aucun" : scans.length} document{scans.length > 1 ? "s" : ""}{" "}
								{scans.length > 1 ? "ont" : scans.length === 1 ? "a" : "n'a"} été scanné{scans.length > 1 ? "s" : ""}{" "}
								{center ? `dans le centre ${center.name}` : "via un scanner non lié à un centre"} dernièrement {scans.length === 0 ? "" : ":"}
							</div>
							<div>
								{addScanOrdoToPrescription && (
									<Label
										as="a"
										onClick={() => {
											refresh(true);
										}}
									>
										Fermer <Icon name="close" />{" "}
									</Label>
								)}
								{!addScanOrdoToPrescription && refresh && center && (
									<Label
										as="a"
										onClick={() => {
											refresh();
										}}
									>
										<Icon name="refresh" />{" "}
									</Label>
								)}
							</div>
						</div>
					</Header>
					<Grid.Column>
						<Card.Group itemsPerRow={4}>
							{scans &&
								scans.length > 0 &&
								scans[0] &&
								scans.map((scan) => (
									<Card
										key={`card-${scan.id}`}
										style={{ border: selectedScan && selectedScan.id === scan.id ? "3px solid rgb(33, 133, 208)" : "none" }}
									>
										<div>
											<Card.Content>
												<div style={{ width: "auto", maxHeight: "25vh", overflowY: "scroll" }}>
													{scan.rectoBase64 && (
														<Image
															label={
																removeScanOrdo && {
																	as: "a",
																	color: "red",
																	corner: "right",
																	icon: "trash",
																	onClick: (e) => {
																		e.preventDefault();
																		removeScanOrdo(scan.id);
																		setSelectedScan(null);
																		e.stopPropagation();
																	},
																}
															}
															src={`data:${scan.format};charset=utf-8;base64,${scan.rectoBase64}`}
															onContextMenu={(e) => e.preventDefault()}
															style={{ cursor: "zoom-in" }}
															onClick={(e) => {
																e.preventDefault();
																setSelectedScan(scan);
															}}
														/>
													)}
													{scan.versoBase64 && (
														<Image
															src={`data:${scan.format};charset=utf-8;base64,${scan.versoBase64}`}
															onContextMenu={(e) => e.preventDefault()}
															onClick={() => setSelectedScan(scan)}
														/>
													)}
												</div>
											</Card.Content>
										</div>
										<Card.Content extra>
											<Icon name="print" />
											<Label>{scan.scanner}</Label>
											Scanné le {moment(scan.created_at).format("DD/MM/YYYY")} à {moment(scan.created_at).format("HH:mm")}
											<br />
											<Icon name="barcode" />
											{scan.barcodes}
										</Card.Content>
									</Card>
								))}
						</Card.Group>
					</Grid.Column>

					{selectedScan && (
						<Grid.Column>
							<Segment>
								<div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "stretch" }}>
									<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "stretch" }}>
										<Header style={{ paddingTop: "5px" }}>
											<Icon name="zoom-in" />
											Aperçu du document sélectionné
										</Header>
										<Label as="a" onClick={() => setSelectedScan(null)}>
											Fermer l'aperçu <Icon name="close" />
										</Label>
									</div>
									{addScanOrdoToPrescription && (
										<Button
											primary
											onClick={() => {
												addScanOrdoToPrescription(selectedScan, prescriptions && prescriptions.length > 0 ? prescriptions[0] : null);
												setSelectedScan(null);
											}}
										>
											Ajouter ce document au dossier
										</Button>
									)}
									<span style={{ fontSize: "1.3em" }}>
										<Icon name="barcode" />
										{selectedScan.barcodes}
									</span>
									<span>
										<Icon name="print" /> <Label>{selectedScan.scanner}</Label> Scanné le {moment(selectedScan.created_at).format("DD/MM/YYYY")} à{" "}
										{moment(selectedScan.created_at).format("HH:mm")}
									</span>
									<MapInteractionCSS minScale={1} maxScale={3}>
										<div style={{ display: "flex", justifyContent: "center", margin: "auto", marginBottom: "10px" }}>
											{selectedScan.rectoBase64 && (
												<Image
													src={`data:${selectedScan.format};charset=utf-8;base64,${selectedScan.rectoBase64}`}
													onContextMenu={(e) => e.preventDefault()}
													style={{ width: "auto", height: "45vh" }}
												/>
											)}
											{selectedScan.versoBase64 && (
												<Image
													src={`data:${selectedScan.format};charset=utf-8;base64,${selectedScan.versoBase64}`}
													onContextMenu={(e) => e.preventDefault()}
													style={{ width: "auto", height: "45vh" }}
												/>
											)}
										</div>
									</MapInteractionCSS>
								</div>
							</Segment>
						</Grid.Column>
					)}
				</Grid.Row>
			</Grid>
		</Segment>
	);
};
export default ScansCenter;
